module.exports = __webpack_public_path__ + "img/header.23eae482.jpg";